import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  btnGroup: {
    '&:not(:first-child)': {
      marginLeft: 0,
    },
  },

  btnGroupRoot: {
    [theme.breakpoints.down(767)]: {
      // maxWidth: '79.5%',
      margin: 'auto',
      //  marginBottom: '10px',
      display: 'block',
    },
    [theme.breakpoints.down(600)]: {
      maxWidth: '80%',
      paddingBottom: '10px',
    },
  },

  toggleBtn: {
    '&$selected': {
      fontWeight: '600',
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        background: theme.palette.primary.dark,
      },
    },
    color: theme.palette.text.secondary,
    textTransform: 'inherit',
    minWidth: '110px',
    borderColor: theme.palette.primary.main,
    fontWeight: 500,
    height: '34px',
    padding: '0px 7px 0px  8px',
    [theme.breakpoints.down(767)]: {
      // borderColor: theme.colors.elementsColor.main,
      width: '50%',
      minWidth: 'auto',
    },
  },
  selected: {
    // '&$select': {
    //   background: theme.colors.elementsColor.light,
    //   color: theme.palette.primary.dark,
    // },
    // background: `${theme.colors.elementsColor.light}`,
    // color: theme.palette.primary.dark,
    // [theme.breakpoints.down(767)]: {
    //   // borderColor: theme.palette.primary.dark,
    // },
    // '& span:nth-child(1)': {
    //   background: theme.colors.elementsColor.light,
    //   color: theme.palette.primary.dark,
    //   fontWeight: '600',
    //   [theme.breakpoints.down(767)]: {
    //     color: theme.palette.primary.dark,
    //     // color: '#ffffff',
    //   },
    // },
  },
  btnLabel: {
    [theme.breakpoints.down(767)]: {
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: '600',
    },
    [theme.breakpoints.down(767)]: {
      fontSize: '12px',
      whiteSpace: 'nowrap',
    },
  },
  smallBtns: {
    height: '34px',
  },
}));

interface IProps {
  summaryType: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

function SummaryTypes(props: IProps) {
  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newSummaryType: React.MouseEvent<HTMLElement>
  ) => {
    _.stopPropagation();
    props.onClick(newSummaryType);
  };
  const classes = useStyles(props);

  return (
    <div>
      <ToggleButtonGroup
        classes={{
          grouped: classes.btnGroup,
          root: classes.btnGroupRoot,
        }}
        color="primary"
        value={props.summaryType}
        exclusive
        onChange={handleChange}
      >
        <ToggleButton
          key={2}
          value="ext"
          // color="textSecondary" // check
          classes={{
            root: classes.toggleBtn,
            selected: classes.selected,
            // TODO: himanshu, Check btn Label in UI
            // label: classes.btnLabel,
          }}
        >
          Key Sentences
        </ToggleButton>
        <ToggleButton
          key={1}
          value="abs"
          classes={{
            root: classes.toggleBtn,
            selected: classes.selected,
            // TODO: himanshu, Check btn Label in UI
            // label: classes.btnLabel,
          }}
        >
          Paragraph
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}

export default SummaryTypes;
